/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-07 10:43:23
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-03 10:41:09
 */
import React from 'react';
import {Button, Breadcrumb, Checkbox, message} from 'antd';
import './index.css'
import Header4 from '../../Header/Header4';
import PublishModal from './publishModal';
import UploadPanel from './uploadPanel';
import {
    getMyCloudDisk,
    getDiskCatalogue,
    saveFolder,
    getDiskCatalogueName,
    getDiskCatalogueNameDesc,
    getDiskCatalogueTime,
    getDiskCatalogueTimeDesc
} from './service/action';
import {connect} from 'react-redux';
import FileEntity from './FileEntity';
import {standardSize} from '../../../utils/tools';
import Move2Modal from './Move2Modal';
import icon_sort1 from '../../../statics/icon-sort1.png'
import icon_sort0 from '../../../statics/icon-sort2.png'
import icon_sort2 from '../../../statics/icon-sort3.png'

const icon_list = [icon_sort0, icon_sort1, icon_sort2]


/**
 * yunpan 主页面
 */
class CloudStorage extends React.Component {
    state = {
        mydisk: {},
        table: [],//当前目录结构[{...},{},{}]       原则上目录结构应该由后台接口获取，前端按需加载
        folder: [],//当前目录面包屑  ['root' '文件夹1' '文件夹1-1']     面包屑有前台来进行控制较合适 
        indeterminate: false,
        checkAll: false,
        checkedList: [],//标记当前选中的条目 
        // checkedList: [],//标记当前选中的条目
        // cursorPos: { top: 0, left: 0 }
        sortNum: 0,
        fileIcon: icon_sort0,
        timeIcon: icon_sort0,
        sortType: 'file',
        isPrivate: 1
    }


    async shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.user.userId !== this.props.user.userId) {
            let mydisk = await getMyCloudDisk(nextProps.user.userId).catch((e) => {
                console.log(e)
            })
            // debugger
            if (!mydisk) {
                return null
            }
            // console.log('检查user信息:',this.props.user);
            let table = await getDiskCatalogue(mydisk.rootId,this.props.user.token)
            // debugger
            let folder = [{name: '我的网盘', id: mydisk.rootId}]
            // console.log(table)
            this.setState({table: table, folder: folder, mydisk: mydisk})

            return true
        }

        return null
    }

    // 有问题，需要测试修改一下逻辑
    async componentDidMount() {
        // debugger
        let mydisk = await getMyCloudDisk(this.props.user.userId).catch((e) => {
            console.log(e)
        })
        console.log(mydisk)
        if (!mydisk) {
            return
        }
        this.loadTable(mydisk.rootId)
        let folder = [{name: '我的网盘', id: mydisk.rootId}]
        this.setState({folder: folder, mydisk: mydisk})
    }

    //d点击 新建文件夹后 触发的函数  -  1 数据库插入接口 2 重新 loadTable
    onClickNewFolder = async () => {
        // debugger 
        // const {folder} = this.state
        var table = this.state.table
        table.push({name: '新建文件夹', type: 0, newTag: true})
        // let currentfloder = folder[folder.length - 1]
        // await newFolder(currentfloder.id, '新建文件夹')
        // this.loadTable(currentfloder.id)

        this.setState({table: table})
    }
    addnewfolder = async (name) => {
        var folder = this.state.folder
        let currentfloder = folder[folder.length - 1]
        await saveFolder({parentId: currentfloder.id, name: name, type: 0})
        this.loadTable(currentfloder.id)
    }
    updateName = async (fileInfo) => {
        var folder = this.state.folder
        let currentfloder = folder[folder.length - 1]
        await saveFolder(fileInfo)
        this.loadTable(currentfloder.id)
    }
    //当上传成功  
    onFileUpload = async (file, res) => {
        console.log(file)
        console.log(res)
        var folder = this.state.folder
        let currentfloder = folder[folder.length - 1]
        let path
        if (res) {
            path = res.payload
        } else {
            path = file.path
        }
        let fileinfo = {
            name: file.name,
            resourcePath: global.support.cloudDownloadUrl + '/group1/' + path,
            size: file.size,
            parentId: file.folder.id,
            ownerUserId: this.props.user.userId,
            uploadStatus: '0',
            type: 1
        }

        await saveFolder(fileinfo)
        this.loadTable(currentfloder.id)
    }
    //点击里文件名称后
    onClickFilename = (floderInfo) => {
        if (floderInfo.type === 0) {
            this.updateFolder(floderInfo)
            this.loadTable(floderInfo.id)
        } else {
            message.info('点击了文件')
            console.log(floderInfo)
        }
    }
    /**
     * 点击了移动到
     * @param {} id
     */
    openMove2 = (file) => {
        this.move2Modal.show()
        this.move2Modal.setState({file})
    }
    updateFolder = (floderInfo) => {
        // 进入目录前 更新面包屑 
        console.log('进入文件夹：' + floderInfo.name)
        var folder = this.state.folder
        if (!folder.find(ele => {
            //防止用户快速连点导致出现的重复添加面包屑的bug
            if (ele.name === floderInfo.name) {
                return true
            } else {
                return false
            }
        })) {
            folder.push({name: floderInfo.name, id: floderInfo.id})
        }
    }
    /**
     * 读取指定网盘目录信息  一级目录即可      并更新面包屑  和列表视图
     * @param {*} floderInfo 目录文件夹自身信息  原则上只包含有 floderInfo.id 这一个信息 需要去数据库读取floderInfo.childrenFolder
     */
    loadTable = async (id) => {
        //这边原则上获取的是不含子目录的file信息 ，然后项后端请求子目录信息  
        console.log('向数据库读取' + id + '的目录信息')
        console.log('检查token',this.props.user)
        let table
        let flag = this.state.isPrivate
        switch (this.state.sortNum) {//判断排序类型：默认、正序、倒叙
            case 0:
                table = await getDiskCatalogue(id, flag,this.props.user.token)
                break;
            case 1:
                if (this.state.sortType === 'file') {//判断排序类型：时间、文件
                    table = await getDiskCatalogueName(id, flag)
                } else {
                    table = await getDiskCatalogueTime(id, flag)
                }
                break;
            case 2:
                if (this.state.sortType === 'file') {
                    table = await getDiskCatalogueNameDesc(id, flag)
                } else {
                    table = await getDiskCatalogueTimeDesc(id, flag)
                }
                break;
            default:
                break;
        }
        console.log(table)
        this.setState({table: table})
    }
    reloadTable = () => {
        var folder = this.state.folder
        let currentfloder = folder[folder.length - 1]
        this.loadTable(currentfloder.id)
    }
    /**
     * 点击了 面包屑  返回某目录
     * @param {*} index 要返回的面包屑的索引
     */
    onClickBreadcrumb = (index) => {
        var folder = this.state.folder
        console.log(folder)
        folder.splice(index + 1)
        console.log(folder)
        this.setState({folder: folder})
        this.loadTable(folder[index].id)
    }
    //点击check了某个条目
    onSelect = (id, ckecked) => {
        let {checkedList} = this.state
        let index = checkedList.indexOf(id)
        if (index === -1) {
            checkedList.push(id)
            console.log('选中了', checkedList)
        } else {
            checkedList.splice(index, 1)
            console.log('选中了', checkedList)
        }
        this.setState({checkedList: checkedList})
    }
    //全选按钮
    //结果全选
    onCheckAll = (e) => {
        let {table} = this.state
        let checkedList = []
        if (e.target.checked) {
            table.forEach((folder) => {
                checkedList.push(folder.id)
            })
            this.setState({checkedList: checkedList})
        } else {
            this.setState({checkedList: []})
        }
    }

    onPublishClick = (file) => {
        console.log(file)
        console.log(this.publishModal)
        this.publishModal.show(file)
    }
    //文件排序
    fileNameSort = () => {
        let num = this.state.sortNum
        if (this.state.sortType === 'file' || this.state.sortType === '') {
            num = (num + 1) % 3
        } else {
            num = 1
            this.setState({
                sortType: 'file',
            })
        }

        this.setState({
            fileIcon: icon_list[num],
            timeIcon: icon_sort0,
            sortNum: num
        })
        this.reloadTable()
    }
    //时间排序
    timeSort = () => {
        let num = this.state.sortNum
        if (this.state.sortType === 'time' || this.state.sortType === '') {
            num = (num + 1) % 3
        } else {
            num = 1
            this.setState({
                sortType: 'time',
            })
        }
        this.setState({
            timeIcon: icon_list[num],
            fileIcon: icon_sort0,
            sortNum: num
        }, () => {
            this.reloadTable()
        })
    }
    //切换个人云盘和公共云盘
    changePrivate = (doc) => {
        if (doc !== this.state.isPrivate) {
            this.setState({
                isPrivate: doc,
                table: []
            })
        }
        if (doc) {
            let folder = [{name: '我的网盘', id: this.state.mydisk.rootId}]
            this.setState({folder: folder}, () => {
                this.reloadTable()
            })
        } else {
            let folder = [{name: '公共网盘', id: 'root'}]
            this.setState({folder: folder}, () => {
                this.reloadTable()
            })
        }


        let tmpMessage = {
            "messageType": "private",
            "contentType": "text",
            "senderId": 1,
            "receiverId": 1,
            "content": "sssssssss"
        }
        // global.client.servicerSend(tmpMessage)
    }

    render() {
        let {checkedList, table, folder, mydisk} = this.state
        let checkAll, checkedPart = false
        let checkallEnable = true
        if (checkedList.length === table.length) {
            checkAll = true
        } else if (checkedList.length === 0) {

        } else {
            checkedPart = true
        }
        if (table.length === 0) {
            checkallEnable = false
        }


        return (<><Header4></Header4>
                <input type="file" accept="/*" id='chatview-fileupload' style={{display: 'none'}}
                       onChange={this.selectFile}></input>
                <div className='clouddisk-main'>
                    <div className="clouddisk-header">
                        <div className='clouddisk-header-tab'>
                            <div
                                className={this.state.isPrivate ? 'clouddisk-header-text-active' : 'clouddisk-header-text'}
                                onClick={() => {
                                    this.changePrivate(1)
                                }}> {'个人云盘'} </div>
                            <div
                                className={this.state.isPrivate ? 'clouddisk-header-text' : 'clouddisk-header-text-active'}
                                onClick={() => {
                                    this.changePrivate(0)
                                }}> {'公共云盘'} </div>
                            <div className='clouddisk-header-volume'
                                 style={{display: this.state.isPrivate ? 'block' : 'none'}}>
                                <div
                                    className='clouddisk-header-volume-text'>{standardSize(mydisk.usageVolume) + ' / ' + standardSize(mydisk.volume)}</div>
                                <div className='clouddisk-header-volume-bar'>
                                    <div className='clouddisk-header-volume-bar-inner'
                                         style={{width: mydisk.usageVolume / mydisk.volume * 100 + "%"}}>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clouddisk-header-divider"></div>
                    <div className="clouddisk-content-top-panel">
                        <div className="clouddisk-content-top"
                             style={{display: this.state.isPrivate ? 'flex' : 'none'}}>
                            <Button id='filePicker' className='clouddisk-upload-btn'>
                                <div className="button_content">
                                    <img alt='' src={require('./img/icon-upload.png')}
                                         style={{width: "3rem", height: "3rem"}}></img>
                                    <span style={{fontSize: "2rem"}}>{'上传'}</span>
                                </div>
                            </Button>
                            <Button className='clouddisk-newfloder-btn' onClick={this.onClickNewFolder.bind(this)}>
                                <div className="button_content">
                                    <img alt='' src={require('./img/icon-newfile.png')}
                                         style={{width: "3rem", height: "3rem"}}></img>
                                    <span style={{fontSize: "2rem"}}>{'新建文件夹'}</span>
                                </div>
                            </Button>
                        </div>
                    </div>
                    <div className="clouddisk-content-panel">
                        <div className="clouddisk-content">
                            <div className="clouddisk-content-operation-panel">
                                <Breadcrumb className="clouddisk-content-operation-title">
                                    {this.state.folder.map((floder, index) =>
                                        <Breadcrumb.Item key={index} onClick={this.onClickBreadcrumb.bind(this, index)}
                                                         style={{cursor: 'pointer'}}>
                                            {floder.name}
                                        </Breadcrumb.Item>
                                    )}
                                    {folder.length > 1 &&
                                        <Breadcrumb.Item>
                                            <div className="clouddisk-bread-return"
                                                 onClick={this.onClickBreadcrumb.bind(this, folder.length - 2)}>返回上一级
                                            </div>
                                        </Breadcrumb.Item>}
                                </Breadcrumb>

                                <div className="clouddisk-content-operation-p">
                                    <div className="clouddisk-content-operation-i-back"></div>
                                    <span className="clouddisk-content-operation-i">i</span>
                                    <span
                                        className="clouddisk-content-operation-select">已选择&nbsp;{checkedList.length}&nbsp;项</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="clouddisk-content-operation-download"
                                          onClick={() => message.info("批量下载功能需要下载客户端")}>批量下载</span>
                                </div>
                                <div className="clouddisk-content-operation-2">
                                    共{table.length}项
                                </div>
                            </div>
                            <div className='clouddisk-table-header'>
                                <div className='clouddisk-tablecell clouddisk-tablecell-checkbox'>
                                    <Checkbox disabled={!checkallEnable} onChange={this.onCheckAll}
                                              indeterminate={checkedPart} checked={checkAll}> </Checkbox>
                                </div>
                                <div className='clouddisk-tablecell-header clouddisk-tablecell-filename'>
                                    <div className='btn-switch'>
                                        文件名
                                        <img src={this.state.fileIcon} className='icon-swicth'
                                             onClick={this.fileNameSort}/>
                                    </div>
                                </div>
                                <div className='clouddisk-tablecell-header clouddisk-tablecell-size'>
                                    大小
                                </div>
                                <div className='clouddisk-tablecell-header clouddisk-tablecell-time'>
                                    <div className='btn-switch'>
                                        时间
                                        <img src={this.state.timeIcon} className='icon-swicth' onClick={this.timeSort}/>
                                    </div>
                                </div>
                                {
                                    this.state.isPrivate ?
                                        <>
                                            <div className='clouddisk-tablecell-header clouddisk-tablecell-author'>
                                                共享状态
                                            </div>
                                            <div className='clouddisk-tablecell-header clouddisk-tablecell-author'>
                                                入库状态
                                            </div>
                                        </>
                                        :
                                        <div className='clouddisk-tablecell-header clouddisk-tablecell-author'>
                                            资源来源
                                        </div>

                                }
                                <div className='clouddisk-tablecell-header clouddisk-tablecell-opration'>
                                    操作
                                </div>
                            </div>
                            <div id='upload-container'></div>
                            <div className='clouddisk-table-contentpanel'>
                                {
                                    this.state.table.map((file, index) => {
                                        return (<FileEntity openMove2={this.openMove2}
                                                            addNewFolder={this.addnewfolder}
                                                            updateName={this.updateName}
                                                            reloadTable={this.reloadTable}
                                                            key={file.id} showMore={this.showMore}
                                                            onPublishClick={this.onPublishClick.bind(this, file)}
                                                            checked={checkedList.indexOf(file.id) !== -1}
                                                            onCheck={this.onSelect}
                                                            onClickFilename={this.onClickFilename}
                                                            data={file}
                                                            isPrivate={this.state.isPrivate}
                                        >
                                        </FileEntity>)
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* <PublishModal ref={ref => this.publishModal = ref} reloadTable={this.reloadTable}></PublishModal> */}
                <PublishModal publishModalOnRef={this.publishModalOnRef} reloadTable={this.reloadTable}></PublishModal>
                <Move2Modal mydisk={this.state.mydisk} reloadTable={this.reloadTable}
                            ref={ref => this.move2Modal = ref}></Move2Modal>
                <UploadPanel usageVolume={this.state.mydisk.usageVolume} totalVolume={this.state.mydisk.volume}
                             folder={folder[folder.length - 1]} onFileUpload={this.onFileUpload}></UploadPanel>
            </>
        );
    }

    publishModalOnRef = (ref) => {
        this.publishModal = ref
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
/**
 * 用来建立 UI 组件的参数到store.dispatch方法的映射。它定义了哪些用户的操作应该当作 Action，传给 Store。它可以是一个函数，也可以是一个对象。
 * @param {*} dispatch
 * @param {*} ownProps 容器组件的props对象
 */
const mapDispatch = (dispatch, ownProps) => ({})
/**
 * connect方法接受两个参数： * mapStateToProps 和 mapDispatchToProps。它们定义了 UI 组件的业务逻辑。
 * mapStateToProps 负责输入逻辑，即将state映射到 UI 组件的参数（props），
 * mapDispatchToProps 负责输出逻辑，即将用户对 UI 组件的操作映射成 Action。
 */
export default connect(mapState, mapDispatch)(CloudStorage);






